import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faDesktop,
    faHandshake,
    faMobileAlt,
    faHashtag,
    faComment,
    faBoxOpen,
    faComments
} from '@fortawesome/free-solid-svg-icons';

import IMask from 'imask';
import { Link } from 'react-router-dom';
import {Helmet} from "react-helmet";

const PhoneSystem = () => {
    useEffect(() => {
        document.title = "Phone Systems | Riverland Technology Services"
        for(var element of document.getElementsByClassName("enquireBtn"))
        {
            element.addEventListener("click", () => {document.getElementById("enquire").scrollIntoView({behavior: "smooth"})});
        }
        var phonemask = IMask(document.getElementById("phoneInput"), {
            mask: [
                {
                    mask: '(00) 0000 0000'
                },
                {
                    mask: '+00 000 000 000'
                }
            ]
        });
    }, []);

    
    return (
       <>
           <Helmet>
               <meta
                   name="description"
                   content="3CX is a major leader in phone systems, and as a 3CX Advanced Certified business, we can help you get your system up and running in no time!"
               />
           </Helmet>
           <section className="section ProductHeroSection WebDevProductHeroSection HeroSection Section--hasGuides theme--light accent--Blue">
                <div className="section_masked">
                    <div className="section_backgroundMask">
                        <div className="section_background">
                            <div className="guides hero-guides">
                                <div className="guidesContainer">
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sectionContainer">
                        <div className="sectionLayoutContainer">
                            <div className="sectionLayout">
                                <div className="RowLayout ProductHeroSection_layout">
                                    <nav className="ProductNav">
                                        <header className="ProductNav_header">
                                            <FontAwesomeIcon className="ProductIcon ProductIcon--webDev ProductNav_icon" transform="up-1.5" icon={faMobileAlt}/>
                                            <h1 className="ProductNav_title">3CX Management</h1>
                                        </header>
                                        <div className="HorizontalOverflowContainer">
                                            <div className="HorizontalOverflowContainer_track">
                                                <div className="HorizontalOverflowContainer_items">
                                                    <ul className="ProductNav_linkList">
                                                        <li className="ProductNavItem ProductNavItem--isActive">
                                                            <Link to="/products/web-development" className="link">Overview</Link>
                                                        </li>
                                                        <li className="ProductNavItem">
                                                            <button className="link enquireBtn">Enquiries</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </nav>
                                    <div className="ProductHeroSection_content">
                                        <div className="RowLayout">
                                            <section className="Copy variant--Hero">
                                                <header className="Copy_header">
                                                    <h1 className="CopyTitle">
                                                        Easy customer interaction
                                                    </h1>
                                                </header>
                                                <div className="Copy_body">
                                                    <p>
                                                        3CX is a major leader in phone systems, and as a 3CX Advanced Certified business, we can help you get your system up and running in no time!
                                                    </p>
                                                </div>
                                                <footer className="Copy_footer">
                                                    <div className="Copy_footerContainer">
                                                        <button className="CtaButton variant--Button CtaButton--arrow HomepageHero_cta enquireBtn">
                                                            Enquire
                                                            <svg class="HoverArrow" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                                                                <g fill-rule="evenodd">
                                                                    <path class="HoverArrow__linePath" d="M0 5h7"></path>
                                                                    <path class="HoverArrow__tipPath" d="M1 1l4 4-4 4"></path>
                                                                </g>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </footer>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section theme--white accent--Blue">
            <div className="section_masked">
                    <div className="section_backgroundMask">
                        <div className="section_background">
                            <div className="guides hero-guides">
                                <div className="guidesContainer">
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sectionContainer">
                        <div className="sectionLayoutContainer">
                            <div className="sectionLayout">
                                <div className="RowLayout">
                                    <div>
                                        <div className="ColumnLayout" data-columns="1,1,1,1">
                                            <div className="Copy variant--Detail">
                                                <header className="Copy_header">
                                                    <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faHashtag} /></div>
                                                    <h1 className="CopyTitle">Wide Range of Numbers</h1>
                                                </header>
                                                <div className="Copy_body">
                                                    We offer a wide range of phone numbers. Whether you want a mobile number, a local number, or a freecall number, we can get it.
                                                </div>
                                            </div>
                                            <div className="Copy variant--Detail">
                                                <header className="Copy_header">
                                                    <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faComment} /></div>
                                                    <h2 className="CopyTitle">SMS</h2>
                                                </header>
                                                <div className="Copy_body">
                                                    If you choose a mobile number, you can even use SMS and MMS capabilities, allowing you to message your clients via text message.
                                                </div>
                                            </div>
                                            <div className="Copy variant--Detail">
                                                <header className="Copy_header">
                                                    <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faBoxOpen} /></div>
                                                    <h2 className="CopyTitle">Flexible Deployments</h2>
                                                </header>
                                                <div className="Copy_body">
                                                    Whether you're a one-man contracter, or a large hotel, 3CX can handle your needs.
                                                </div>
                                            </div>
                                            <div className="Copy variant--Detail">
                                                <header className="Copy_header">
                                                    <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faComments} /></div>
                                                    <h2 className="CopyTitle">Live Chat</h2>
                                                </header>
                                                <div className="Copy_body">
                                                    We can integrate 3CX into your website, whether it's managed by Riverland Technology Services, or someone else, so customers can chat to you straight from your website that you can talk back to from your 3CX system.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section theme--light accent--Blue">
                <div className="section_masked">
                    <div className="section_backgroundMask">
                        <div className="section_background">
                            <div className="guides hero-guides">
                                <div className="guidesContainer">
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sectionContainer">
                        <div className="sectionLayoutContainer">
                            <div className="sectionLayout">
                                <div className="RowLayout" style={{"--rowLayoutGap": "32px"}}>
                                    <div className="ColumnLayout" data-columns="2,2">
                                        <section className="Copy variant--Section HomepagePlatformCopy" style={{"--paddingRight": "16px"}}>
                                            <header className="Copy_header">
                                                <h2 className="CopyCaption">Awesome Features</h2>
                                                <h1 className="CopyTitle">3CX can suit any businesses needs!</h1>
                                            </header>
                                        </section>
                                    </div>
                                    <div className="ColumnLayout" data-columns="2,2">
                                        <section className="Copy variant--Section" style={{"--paddingRight": "var(--columnPaddingMedium)"}}>
                                            <div className="Copy_body">
                                                <p>
                                                    3CX can be used as just a simple mobile app on your phone, or can be used with hundreds of desk phones, at a hotel with lots of rooms, or even just a large office, and it won't even break a sweat.
                                                </p>
                                            </div>
                                        </section>

                                        <section className="Copy variant--Section" style={{"--paddingRight": "var(--columnPaddingXLarge)"}}>
                                            <div className="Copy_body">
                                                <p>
                                                    As a 3CX Advanced Certified business, we can make sure that your deployment uses all of the features you could need. <a href="https://3cx.com" class="link">Learn More about 3CX</a>
                                                </p>
                                            </div>
                                        </section>
                                    </div>
                                    <div className="ColumnLayout" data-columns="2,2">
                                        <section className="Copy variant--Section">
                                            <footer className="Copy_footer">
                                                <div className="Copy_footerContainer">
                                                    <button className="CtaButton variant--Button CtaButton--arrow HomepageHero_cta enquireBtn">
                                                        Enquire
                                                        <svg class="HoverArrow" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                                                            <g fill-rule="evenodd">
                                                                <path class="HoverArrow__linePath" d="M0 5h7"></path>
                                                                <path class="HoverArrow__tipPath" d="M1 1l4 4-4 4"></path>
                                                            </g>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </footer>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section theme--dark accent--Blue" id="enquire">
                <div className="section_masked">
                    <div className="section_backgroundMask">
                        <div className="section_background">
                            <div className="guides hero-guides">
                                <div className="guidesContainer">
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sectionContainer">
                        <div className="sectionLayoutContainer">
                            <div className="sectionLayout">
                                <div className="RowLayout" style={{"--rowLayoutGap": "32px"}}>
                                    <div className="ColumnLayout" data-columns="2,2" data-tablet-columns="1">
                                        <div>
                                            <section className="Copy variant--Section HomepagePlatformCopy" style={{"--paddingRight": "16px", paddingBottom: "16px"}}>
                                                <header className="Copy_header">
                                                    <h2 className="CopyCaption">Enquiries</h2>
                                                    <h1 className="CopyTitle">Interested getting better communications?</h1>
                                                </header>
                                            </section>
                                            <section className="Copy variant--Section" style={{"--paddingRight": "var(--columnPaddingMedium)"}}>
                                                <div className="Copy_body">
                                                    <p>
                                                        Whether you want to not use your personal phone number, or are a large office needing a new system, we can help you! If you are interested, please fill out the enquriry form.
                                                    </p>
                                                </div>
                                            </section>
                                        </div>
                                        <div>
                                            <section className="enquireForm">
                                                <div className="formContainer">
                                                    <form action="/api/v1/enquiries/enquire.php" method="post">
                                                        <input hidden name="enquireProduct" value="phonesystem"></input>
                                                        <ul className="formList">
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">First Name</span></div><div className="formInputContainer"><input className="formInput" type="text" name="firstNameInput" id="firstNameInput" placeholder="John" required /></div></li>
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Last Name</span></div><div className="formInputContainer"><input className="formInput" type="text" name="lastNameInput" id="lastNameInput" placeholder="Doe" required /></div></li>
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Business Name</span></div><div className="formInputContainer"><input className="formInput" type="text" name="businessNameInput" id="businessNameInput" placeholder="Atom Technology" required /></div></li>
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Email Address</span></div><div className="formInputContainer"><input className="formInput" type="email" name="emailInput" id="emailInput" placeholder="john@atom.tech" required /></div></li>
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Phone Number</span></div><div className="formInputContainer"><input className="formInput" type="text" name="phoneInput" id="phoneInput" placeholder="(xx) xxxx xxxx/+xx xxx xxx xxx" required /></div></li>
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Notes</span><span className="formLabelDescription">Optional</span></div><div className="formInputContainer"><textarea className="formInput" type="textarea" name="notesInput" id="notesInput" /></div></li>
                                                            <li className="formItem">
                                                                <div className="formLabelContainer">
                                                                    <span className="formLabel">Features</span>
                                                                    <span className="formLabelDescription">Which features are you interested in?</span>
                                                                </div>
                                                                <div className="formInputContainer">
                                                                    <fieldset className="formRadioFieldset">
                                                                        <label className="CheckboxField">
                                                                            <input type="checkbox" name="featuresInput" value="sms" className="CheckboxField_hiddenInput" />
                                                                            <span className="CheckboxField_checkbox">
                                                                                <svg class="CheckboxField__check" width="16" height="8" viewBox="0 0 8 7"><path d="M7.16.18L2.4 4.79 1.13 3.43a.7.7 0 0 0-.87-.04.61.61 0 0 0-.18.8l1.5 2.45c.15.22.41.36.69.36.28 0 .53-.14.68-.36C3.2 6.33 7.77.86 7.77.86c.6-.6-.13-1.15-.6-.68z" fill="var(--knockoutColor)"></path></svg>
                                                                            </span>
                                                                            <span className="CheckboxField_label">
                                                                                SMS
                                                                            </span>
                                                                        </label>
                                                                        <label className="CheckboxField">
                                                                            <input type="checkbox" name="featuresInput" value="chat" className="CheckboxField_hiddenInput" />
                                                                            <span className="CheckboxField_checkbox">
                                                                                <svg class="CheckboxField__check" width="16" height="8" viewBox="0 0 8 7"><path d="M7.16.18L2.4 4.79 1.13 3.43a.7.7 0 0 0-.87-.04.61.61 0 0 0-.18.8l1.5 2.45c.15.22.41.36.69.36.28 0 .53-.14.68-.36C3.2 6.33 7.77.86 7.77.86c.6-.6-.13-1.15-.6-.68z" fill="var(--knockoutColor)"></path></svg>
                                                                            </span>
                                                                            <span className="CheckboxField_label">
                                                                                Live Chat
                                                                            </span>
                                                                        </label>
                                                                    </fieldset>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        <div className="formFooter">
                                                            <button type="submit" name="submit" className="CtaButton variant--Button CtaButton--arrow HomepageHero_cta">
                                                                Submit
                                                                <svg class="HoverArrow" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                                                                    <g fill-rule="evenodd">
                                                                        <path class="HoverArrow__linePath" d="M0 5h7"></path>
                                                                        <path class="HoverArrow__tipPath" d="M1 1l4 4-4 4"></path>
                                                                    </g>
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
       </>
    );
}

export default PhoneSystem